export const API_KEY = "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"